import { FilterUtils } from '@elotech/components';
import { isNumber } from 'common/utils';
import { axios } from 'libs';

const resource = '/tiposprocesso';

const defaultSort = {
  sort: 'id,asc'
};

export const findAllAutocomplete = (
  search = '',
  entidadeAtual,
  pagination,
  sort = defaultSort
) => {
  let filter = isNumber(search)
    ? `id==${search}`
    : FilterUtils.buildFilter(['descricao'])(search);

  filter += ' and ativo==true';

  return axios.get(`${resource}/find-all-filtrado-entidade`, {
    params: {
      search: filter,
      entidadeAtual,
      ...sort,
      ...pagination
    }
  });
};

export const findAllAutocompleteTipoExterno = (
  search = '',
  entidadeAtual,
  pagination,
  sort = defaultSort
) => {
  let filter = isNumber(search)
    ? `id==${search}`
    : FilterUtils.buildFilter(['descricao'])(search);

  filter += ' and ativo==true and tipoInterno==false';

  return axios.get(`${resource}/find-all-filtrado-entidade`, {
    params: {
      search: filter,
      entidadeAtual,
      ...sort,
      ...pagination
    }
  });
};

export const findAllLogs = id => {
  return axios.get(`${resource}/history${id}`);
};

export const findAll = (search, pagination, sort = defaultSort) => {
  return axios.get(resource, {
    params: {
      search,
      ...sort,
      ...pagination
    }
  });
};

export const findById = id => {
  return axios.get(`${resource}/${id}`);
};

export const deleteById = id => {
  return axios.delete(`${resource}/${id}`);
};

export const save = tipo => {
  return tipo.id
    ? axios.put(`${resource}/${tipo.id}`, tipo)
    : axios.post(resource, tipo);
};

export const republish = () => {
  return axios.post(`${resource}/republish`);
};

export const findAllAutocompleteConsultaExterna = (
  search = '',
  entidadeAtual,
  pagination,
  sort = defaultSort
) => {
  let filter = isNumber(search)
    ? `id==${search}`
    : FilterUtils.buildFilter(['descricao'])(search);

  filter += ' and ativo==true and consultaExterna==true';

  return axios.get(`${resource}/find-all-filtrado-entidade`, {
    params: {
      search: filter,
      entidadeAtual,
      ...sort,
      ...pagination
    }
  });
};
